import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { authService } from '../services/auth';
import { ApiError } from '../services/api';
import { clearPerUserBrowserStorage } from '../services/storageCleanup';

function handleUnauthorized(error: unknown) {
  if (error instanceof ApiError && error.status === 401) {
    authService.clearTokens();
    authService.clearUserInfo();
    // Match the deliberate-logout cleanup so a session-expiry → re-login on the
    // same device doesn't inherit the previous user's per-league read state or
    // cached API responses. The hard navigation below tears down in-memory state.
    clearPerUserBrowserStorage();
    window.location.href = '/login';
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handleUnauthorized }),
  mutationCache: new MutationCache({ onError: handleUnauthorized }),
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: (failureCount, error) => {
        // Never retry on 401 — token is invalid, redirect immediately
        if (error instanceof ApiError && error.status === 401) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});
